<template>
    <InputNumber :value="value"
        :max="max"
        :min="min"
        :precision="precision"
        :active-change="false"
        :disabled="disabled"
        :readonly="readonly"
        class="number-input"
        @on-change="onChange"
        @on-focus="onFocus"/>
</template>

<script>
import './number.less';
import NumberMixins from './number-mixins';

export default {
    name: 'DecimalInput',
    mixins: [NumberMixins],
    props: {
        precision: {
            type: Number,
            default: 2
        }
    },
    data() {
        return {};
    },
    methods: {
        onFocus(e){
            e.target.select();
        }
    }
};
</script>

<style scoped>
</style>
